import { render, staticRenderFns } from "./SendBankPeapme.vue?vue&type=template&id=589a4137&scoped=true"
import script from "./SendBankPeapme.vue?vue&type=script&lang=js"
export * from "./SendBankPeapme.vue?vue&type=script&lang=js"
import style0 from "./SendBankPeapme.vue?vue&type=style&index=0&id=589a4137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a4137",
  null
  
)

export default component.exports